exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tabs-logs--text-green,\n.tabs-logs--text-green a {\n  color: #0a8f3f;\n}\n.tabs-logs--text-red,\n.tabs-logs--text-red a {\n  color: #c0392b;\n}\n.tabs-logs--text-muted,\n.tabs-logs--text-muted a {\n  color: #7a869a;\n}\n.tabs-logs__table-entry-col--entry-box-header span.link-color a {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n}\n.tabs-logs__table-entry-col--entry-box-header span.link-color a:hover {\n    color: #007bff;\n    text-decoration: none;\n    background-color: transparent;\n}\n.link-color a.audit-link,\n.tabs-logs__title.link-color a.audit-link {\n  color: #007bff;\n  text-decoration: underline;\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-40a8e3c3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/ReservationEditV2/TabLogs/TabLogs.vue
// module id = 2034
// module chunks = 0